import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { OidcService } from '../oidc/oidc.service';
import { PartnerService } from '../shared/utils/partner.service';
import { OAuthService } from 'angular-oauth2-oidc';
import {ApiRegistrationService} from "../shared/api/api.registration.service";
import {Store} from "@ngrx/store";
import UserProfile from "../shared/models/userProfile";
import {isObjectNullOrEmpty} from '../shared/utils/objectNullOrEmpty';
import AppState from '../store';
import { selectUserProfile } from '../store/userProfile/userProfile.selector';
import { take } from 'rxjs/operators';
/**
 * Class that blocks access to routes which are intended for authorized users
 */
@Injectable()
export class RouteGuardService implements CanActivate {
  userProfile: UserProfile;

  constructor(
    private oidcService: OidcService,
    private oauthService: OAuthService,
    private partnerService: PartnerService,
    private apiRegistrationService: ApiRegistrationService,
    private router: Router,
    private store: Store<AppState>
  ) {
    this.store.select(selectUserProfile).pipe(take(1)).subscribe(userProfile => {
      if(userProfile) {
        this.userProfile = userProfile;
      }
    });
  }

  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    await this.oauthService.loadDiscoveryDocument();

    await this.oauthService.tryLogin();

    await this.handleIncompleteRegistration();

    if (this.partnerService.isPartnerVital10()) {
      return state.url.indexOf('partner') !== -1 || state.url.indexOf('login-vital10') !== -1;
    }

    const allowedToAccessRoute = this.oidcService.isAuthenticated() && !this.partnerService.isPartnerVital10();
    if (!allowedToAccessRoute) {
      // check for refresh token
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          await this.oidcService.refreshToken();

          const idToken = this.oauthService.getIdToken();
          if (idToken) {
            const claims = this.oauthService.getIdentityClaims();

            if (!claims) {
              const payload = this.oidcService.extractPayloadFromToken(idToken);
              localStorage.setItem('id_token_claims_obj', JSON.stringify(payload));
            }
          }
          return true;
        } catch (e) {
          console.error('Token refresh failed:', e);
        }
      }

      console.error('NOT AUTHORIZED TO ACCESS ROUTE!');
      return this.router.parseUrl('/');
    }
    return true;
  }

  private async handleIncompleteRegistration(): Promise<boolean> {
    if(this.oidcService.isAuthenticated() && this.isRequiredRegistrationFieldNullOrEmpty()) {
      const step = await this.apiRegistrationService.getIncompleteRegistrationSteps();
      if (step) {
        await this.router.navigateByUrl('/register/' + step);
        return false;
      }
    }
    return true;
  }

  isRequiredRegistrationFieldNullOrEmpty() {
    return isObjectNullOrEmpty(this.userProfile?.generalInformation?.firstName) ||
          isObjectNullOrEmpty(this.userProfile?.generalInformation?.lastName) ||
          isObjectNullOrEmpty(this.userProfile?.generalInformation?.gender) ||
          isObjectNullOrEmpty(this.userProfile?.generalInformation?.phoneNumber);
  }
}
